import type { RemoteVendorProduct } from "../../../../features/interfaces";

export type RemoteProductFilters = {
  name: string;
  status: string;
};

/** Pure filter — no UI or data-fetching concerns (SRP). */
export function filterRemoteProducts(
  products: RemoteVendorProduct[],
  filters: RemoteProductFilters
): RemoteVendorProduct[] {
  const query = filters.name.trim().toLowerCase();
  const status = filters.status.trim().toLowerCase();

  return products.filter((product) => {
    if (status && (product.status || "").toLowerCase() !== status) {
      return false;
    }
    if (!query) return true;
    const title = (product.title || "").toLowerCase();
    const description = (product.description || "").toLowerCase();
    return title.includes(query) || description.includes(query);
  });
}

export function collectRemoteProductStatuses(
  products: RemoteVendorProduct[]
): string[] {
  const unique = new Set<string>();
  products.forEach((product) => {
    if (product.status?.trim()) {
      unique.add(product.status.trim().toLowerCase());
    }
  });
  return Array.from(unique).sort();
}
